export default __webpack_public_path__ + "static/media/google-logo-pink.59dd514b.svg";